import React from 'react'
import AdminLayout from 'cms/core/shared/AdminLayout'
import CategoryList from '../components/CategoryList'

function CategoryScreen() {
  return (
    <AdminLayout pageTitle="Categories">
      <CategoryList />
    </AdminLayout>
  )
}

export default CategoryScreen

